<script setup lang="ts">
  import { message } from "ant-design-vue";
  import JsCookies from "js-cookie";
  import { getCurrentInstance, onMounted, ref } from "vue";
  import { ADVERTISE_MODAL } from "~/enum/cache/cookie";
  import { useMainStore } from "~/stores";

  const props = defineProps<{
    platform: string; // 1：官网，2：法搜，3：律助，4法务，5：法搜app，6：律助app，7：法搜小程序
  }>();

  const instance = getCurrentInstance()?.proxy as any;
  const store = useMainStore();

  const isShow = ref(false);
  const data = ref<any[]>([]);
  const loadData = () => {
    const params = { platform: props.platform, position: "open", versionType: store.versionType };
    instance.$Request.get("/api/v1/promotion/queryPlatformBanners", params).then((res: any) => {
      data.value = res;
      if (res.length > 0 && !JsCookies.get(ADVERTISE_MODAL)) isShow.value = true;
    });
  };

  const onClose = () => {
    JsCookies.set(ADVERTISE_MODAL, "true");
    isShow.value = false;
  };

  const toUrl = () => {
    JsCookies.set(ADVERTISE_MODAL, "true");
    if (data.value[0].targetGroup === 6) {
      instance.$Request
        .post("/api/v1/promotion/bannerGiveLicense", {
          id: data.value[0].id,
        })
        .then(() => {
          message.success("恭喜您，成功领取一个月SVIP会员");
        });
    } else {
      window.open(data.value[0].linkUrl, "_blank");
    }
    isShow.value = false;
  };

  onMounted(() => {
    loadData();
  });
</script>

<template>
  <a-modal
    v-if="data.length"
    wrap-class-name="advertise-modal"
    :open="isShow"
    :centered="true"
    :keyboard="false"
    :mask-closable="false"
    :footer="null"
    @cancel="onClose">
    <template #closeIcon>
      <icon-font type="module-a-Slice267" />
    </template>
    <img class="advertise-modal-img" :src="data[0].banner" @click="toUrl()" />
  </a-modal>
</template>

<style lang="less">
  .advertise-modal {
    div[class^="ant-modal"] {
      width: fit-content !important;
      padding: 0;
      background-color: transparent !important;
      box-shadow: none;
    }

    .ant-modal-content {
      padding-right: 56px !important;

      .ant-modal-close {
        top: 0;
        right: 0;

        .ant-modal-close-x {
          width: 40px !important;
          height: 40px !important;

          .anticon {
            font-size: 40px !important;
          }
        }
      }

      .ant-modal-body {
        padding: 0 !important;
      }
    }

    .advertise-modal-img {
      cursor: pointer;
    }
  }
</style>
